module.exports = __webpack_public_path__ + "static/img/play-btn=-.78da13e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/play-btn=-.png
// module id = Axqx
// module chunks = 0